export const StubProjectsPageTexts = {
  thisPage: 'Cette page',
  will: 'sera',
  be: 'bientôt',
  readySoon: 'disponible',
};
